import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ShippingAddressForm";
import {GET_SHIPPING_ADDRESS_FOR_EDIT} from "../../queries/customers";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelUpdateShippingAddress, requestRemoveShippingAddress} from "../../actions/AccountApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateShippingAddress} from "../../lib/AddressValidation";

function validateForm(values, props) {
  return validateShippingAddress(values).toJS();
}

class EditShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId);
    return this.props.updateShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.updateShippingAddress.errors.length <= 0) {
          this.props.cancelUpdateShippingAddress();
        } else {
          let errors = createValidationErrors(response.data.updateShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelUpdateShippingAddress();
  }

  handleDelete() {
    this.props.cancelUpdateShippingAddress();
    this.props.requestRemoveShippingAddress(
      this.props.data.shippingAddress.accountId,
      this.props.data.shippingAddress.addressId
    );
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.availableCountriesForAccount);
    let address = fromJS(data.shippingAddress);
    let initialValues = {
      addressId: address.get("addressId", ""),
      type: address.get("type", ""),
      name: address.get("name", ""),
      addressAddressLine1: address.get("addressAddressLine1", ""),
      addressAddressLine2: address.get("addressAddressLine2", ""),
      addressCity: address.get("addressCity", ""),
      addressStateProvince: address.get("addressStateProvince", ""),
      addressPostcode: address.get("addressPostcode", ""),
      addressCountryCode: address.get("addressCountryCode", "")
    }
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showStateProvince={this.props.showStateProvince}
        showDelete={this}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onDelete={this.handleDelete.bind(this)}
        />
    )
  }
}

const UPDATE_SHIPPING_ADDRESS = gql`
  mutation updateShippingAddress($data: ShippingAddressInput!) {
    updateShippingAddress(input: $data) {
      errors { key message }
    }
  }
`;

const withAddressQuery = compose(
  graphql(GET_SHIPPING_ADDRESS_FOR_EDIT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        addressId: props.addressId
      }
    })
  }),
  graphql(UPDATE_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      updateShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const EditShippingAddressFormContainerWithData = withAddressQuery(EditShippingAddressFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelUpdateShippingAddress, requestRemoveShippingAddress})(EditShippingAddressFormContainerWithData);